import { Dispatch, SetStateAction } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { EnumTechPlatform } from 'tdc-web-backend/enums/enums';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import { Box } from '@mui/system';
import ConfirmModal from '../../../../../../../components/confirm-modal/ConfirmModal';
import { ReactComponent as SuitcaseCheckIcon } from '../../../../../../../assets/icons/layout-icons/SuitcaseCheckIcon.svg';
import { primaryLight } from '../../../../../../../utils/color';
import { useRefresh } from '../../../../../../../utils/hooks/crud-hooks/useRefresh';
import useUpdate from '../../../../../../../utils/hooks/crud-hooks/useUpdate';
import { mapTechPlatform } from '../../../../../../../utils/enums';
import CustomInput from '../../../../../../../components/custom-input/CustomInput';
import { useSellerHomescreenContext } from '../../../SellerHomescreenContext';

interface CompanyTechPlatformsProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTechPlatformsEditModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTechPlatformsProps) => {
  const refresh = useRefresh();
  const { companyData } = useSellerHomescreenContext();

  const methods = useForm<Pick<CompanyDto, 'techPlatforms'>>({
    mode: 'onChange',
    defaultValues: {
      techPlatforms: companyData?.techPlatforms ?? ([] as EnumTechPlatform[]),
    },
  });

  const { mutate: update, isLoading } = useUpdate<CompanyDto, Partial<CompanyDto>>({
    resource: 'companies',
  });

  const onSubmit = (data: Pick<CompanyDto, 'techPlatforms'>) => {
    update(
      { id: companyData?.id as string, data },
      {
        onSuccess: () => {
          refresh();
          setIsEditModalOpen(false);
        },
      },
    );
  };

  return (
    <ConfirmModal
      width="40%"
      title="Tech platforms"
      onCancel={() => setIsEditModalOpen(false)}
      onConfirm={methods.handleSubmit(onSubmit)}
      isModalOpen={isEditModalOpen}
      setIsModalOpen={setIsEditModalOpen}
      automaticallyCloseModalOnButtonClick={false}
      isLoading={isLoading}
      confirmButtonText="Save"
      iconProps={{
        icon: <SuitcaseCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: primaryLight[100],
      }}
      message={
        <FormProvider {...methods}>
          <Box component="form">
            <CustomInput
              input={<CustomInput.Autocomplete />}
              choices={mapTechPlatform}
              name="techPlatforms"
              label="Tech platforms"
              multiple
              placeholder="Select tech platforms"
              sx={{ width: '100%' }}
            />
          </Box>
        </FormProvider>
      }
    />
  );
};

export default CompanyTechPlatformsEditModal;
